import { useEffect, useState, createRef } from 'react'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
// components
import { Card, Row, Col } from 'react-bootstrap'
import {
	TextInput,
	TextArea,
	DatePicker,
	DatePickerInput,
	Toggle,
} from 'carbon-components-react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import SelectLabel from '../../../components/SelectLabel'
// import FieldGroupArray from './detailConneX/FieldGroupArray'
import FieldGroupArray from '../../StudyDetails/DetailSections/detailConneX/FieldGroupArray';
// hooks
import useAgeField from '../../../helpers/useAgeFields'
// constants
import {
	getRecruitStatusOptions,
	getSexOptions,
	getTrialPhaseOptions,
	getTrialTypeOptions,
} from '../../../constants/connex'
// styles
import styled from 'styled-components';
import {
	selectStyles,
	getSelectValuesToSubmit,
	getValuesForReactSelect,
} from '../../../helpers/formUtils'
// api
import { getSimpleConditions } from '../../../api/conditions'

const DetailCTG = ({
	data,
	refs,
	setRefs,
	getFieldValue,
	// dirtyFields,
	// dataToSubmit,
	// setDataToSubmit,
	// SET_OVERRIDE_DATA,
}) => {
	const [conditionOptions, setConditionOptions] = useState(null)

	useEffect(() => {
		let _refs = []
		for (let i = 0; i < 5; i++) {
			_refs.push(createRef());
		}
		setRefs(_refs)
	}, [])

	// add id with index number to data
	const addIdsToDataArray = (dataArray) => {
		if (dataArray) {
			return dataArray.map((item, index) => {
				let newItem = { ...item }
				newItem.orderId = index + 1
				newItem.id = uuidv4()
				return newItem
			})
		}
		return null
	}

	// fields defining array fields

	const trialArmsFields = [
		{
			id: "description",
			labelText: "Description",
			type: "textArea",
			rows: 3,
		},
		{
			id: "arm_group_label",
			labelText: "Label",
			type: "textArea",
			rows: 1,
		},
		{
			id: "arm_group_type",
			labelText: "Type",
			type: "textInput",
		},
	]

	const outcomeMeasureFields = [
		{
			id: "description",
			labelText: "Description",
			type: "textArea",
			rows: 3,
		},
		{
			id: "measure",
			labelText: "Measure",
			type: "textArea",
			rows: 2,
		},
		{
			id: "time_frame",
			labelText: "Time Frame",
			type: "textInput",
		},
	]

	useEffect(() => {
		getSimpleConditions().then((res) => {
			setConditionOptions(getValuesForReactSelect(res))
		})
	}, [])


	/** RENDERERS */

	const fieldHeaderRow = () => {
		return <Row>
				<SubSectionHeader>Original values</SubSectionHeader>
		</Row>

	}

	const getTextRow = (type, id, label, moreProps) => {
		const propsAll = {
			labelText: label,
			size: 'sm',
		}
		const overrideProps = {
			id,
			defaultValue: getFieldValue(id, 'override'),
			// onChange: onTextFieldChange,
		}
		const origProps = {
			id: `orig_${id}`,
			value: getFieldValue(id, 'ctg_data'),
			readOnly: true,
			disabled: data?.override?.[id],
			onFocus: (evt) => evt.target.select(),
		}
		return <Row className="mb-4">
			<Col>
				<OrigTextFieldStyled>
					{type === 'textInput' ?
						<TextInput
							{...propsAll}
							{...origProps}
							{...moreProps}
						/> :
						<TextArea
							{...propsAll}
							{...origProps}
							{...moreProps}
						/>
					}
				</OrigTextFieldStyled>
			</Col>
		</Row>
	}

	const getDatePickerRow = (fieldId, label) => {
		let origValue = getFieldValue(fieldId, 'ctg_data')
		if (origValue) {
			origValue = moment(origValue).format('MM/DD/YYYY')
		} else {
			origValue = ''
		}
		let overrideValue = getFieldValue(fieldId, 'override')
		if (overrideValue) {
			overrideValue = moment(overrideValue).format('MM/DD/YYYY')
		} else {
			overrideValue = ''
		}
		return <Row className="mb-4">
			<Col>
				<OrigTextFieldStyled>
					<TextInput
						id={`orig_${fieldId}`}
						labelText={label}
						value={origValue}
						size="sm"
						readOnly={true}
						onFocus={(evt) => evt.target.select()}
						disabled={overrideValue}
					/>
				</OrigTextFieldStyled>
			</Col>
		</Row>
	}

	/**
		* @param {String} id data key, eg, "brief_summary"
		* @param {String} label field label
		* @param {Object} selectOptions React Select format, eg, { value, label }
		* @param {Boolean} isMulti multi vs. single-value
		* @returns JSX
		*/
	const getSelectRow = (
		id,
		label,
		selectOptions,
		isMulti = false,
	) => {
		const defaultOverrideValue = getValuesForReactSelect(data?.override?.[id], selectOptions)
		const isOverriden = defaultOverrideValue?.length > 0

		const originalValues = (val) => {
			let displayVal = null
			if (!val) {
				// empty
				displayVal = <>&nbsp;</>
			} else if (Array.isArray(val) && val?.length) {
				// multi-value select with tags
				displayVal = val.map((text) => <OrigValueTagStyled
					key={text}
					isOverridden={isOverriden}
				>{text}</OrigValueTagStyled>)
			} else {
				// sigle-value select
				displayVal = <OrigSelectValueStyled>{val}</OrigSelectValueStyled>
			}
			return <>{displayVal}</>
		}

		const getArrayOfStrings = (items) => {
			if (items?.length) {
				return items.map((item) => (item.name))
			}
		}

		return <Row className="mb-4">
			<Col>
				<OriginalSelectStyled
					isOverridden={isOverriden}
				>
					<label className="bx--label">
						{label}
					</label>
					<div className="orig-select-inner-box">
						{isMulti ?
						originalValues(getArrayOfStrings(getFieldValue(id)))
						:
						originalValues(getFieldValue(id, 'ctg_data'))
						}
					</div>
				</OriginalSelectStyled>
			</Col>
		</Row>
	}

	/**
		* @param {String} id data key, eg, "brief_summary"
		* @param {String} label field label
		* @param {Object} selectOptions React Select format, eg, { value, label }
		* @param {Boolean} isMulti multi vs. single-value
		* @returns JSX
		*/
		const getSelectCreatableRow = (
			id,
			label,
			selectOptions,
			isMulti = false,
		) => {
			let defaultOverrideValue;
			if(id === "conditions"){
				defaultOverrideValue = getValuesForReactSelect(data?.conditions_override, selectOptions);
			}
			else{
				defaultOverrideValue = getValuesForReactSelect(data?.override?.[id], selectOptions);
			}
			
			const isOverriden = defaultOverrideValue?.length > 0
	
			const originalValues = (val) => {
				let displayVal = null
				if (!val) {
					// empty
					displayVal = <>&nbsp;</>
				} else if (Array.isArray(val) && val?.length) {
					// multi-value select with tags
					displayVal = val.map((text) => <OrigValueTagStyled
						key={text}
						isOverridden={isOverriden}
					>{text}</OrigValueTagStyled>)
				} else {
					// sigle-value select
					displayVal = <OrigSelectValueStyled>{val}</OrigSelectValueStyled>
				}
				return <>{displayVal}</>
			}
	
			const getArrayOfStrings = (items) => {
				if (items?.length) {
					return items.map((item) => (item.name))
				}
			}
	
			return <Row className="mb-4">
				<Col>
					<OriginalSelectStyled
						isOverridden={isOverriden}
					>
						<label className="bx--label">
							{label}
						</label>
						<div className="orig-select-inner-box">
							{isMulti ?
							originalValues(getArrayOfStrings(getFieldValue(id)))
							:
							originalValues(getFieldValue(id, 'ctg_data'))
							}
						</div>
					</OriginalSelectStyled>
				</Col>
			</Row>
		}

	const getSelectAge = (id, label) => {
		return <Row
			className="mb-4"
			style={{ alignItems: 'flex-end' }}
		>
			<Col xs={6}>
				<OriginalSelectStyled
					isOverridden={data?.override?.[id]}
				>
					<label className="bx--label">
						{label}
					</label>
					<div className="orig-select-inner-box">
						<OrigSelectValueStyled>
							{getFieldValue(id, 'ctg_data')}
						</OrigSelectValueStyled>
					</div>
				</OriginalSelectStyled>
			</Col>
		</Row>
	}

	// TODO: make it more abstract, rather than just for "accept_healthy_volunteers"?
	const getToggle = (id) => {
		const defaultToggled = data?.override?.[id] === 'Yes'

		const acceptsVolunteers = () => {
			if (data?.ctg_data?.[id]) {
				const accepts = data.ctg_data[id].toLowerCase()
				if (accepts === 'no') {
					return false
				} else if (accepts === 'yes') {
					return true
				}
			}
			return null
		}

		return <Row
			className="mb-3"
			style={{ alignItems: 'flex-end' }}
		>
			<Col>
				{(acceptsVolunteers || acceptsVolunteers === false) ?
					<OrigToggleStyled
						isOverridden={data?.override?.[id]}
					>
						<Toggle
							id={`orig_${id}`}
							labelA="Does Not Accept Healthy Volunteers"
							labelB="Accepts Healthy Volunteers"
							disabled={true}
						/>
					</OrigToggleStyled>
					: <div>No answer</div>}
			</Col>
		</Row>
	}

	const getFieldGroupArray = (id, title, fields) => {
		const overrideData = data?.override?.[id]
		const origData = addIdsToDataArray(data?.ctg_data?.[id])
		// const submitData = dataToSubmit?.override?.[id]
		// const isDirty = dirtyFields?.override?.[id]
		return <OverrideCardStyled>
			<Row className="mb-4">
				<Col>
					<SelectLabel
						id={id}
					>{title}</SelectLabel>
					<Row>
						<FieldGroupArray
							id={id}
							fieldMap={fields}
							sourceData={origData}
							readOnly={true}
							className="mb-2"
							colProps={{ xs: "12" }}
						/>
					</Row>
				</Col>
			</Row>
		</OverrideCardStyled>

	}

	const OverrideCardStyled = styled.div`
		.card-footer {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 1rem;
		}
	`

	return <>
		<Card
			ref={refs[0]}
			className="mt-4"
		>
			<Card.Header>Trial Overview</Card.Header>
			<Card.Body>
				{fieldHeaderRow()}
				{getTextRow('textInput', 'brief_title', 'Brief Title')}
				{getTextRow('textInput', 'official_title', 'Official Title')}
				{getTextRow('textArea', 'brief_summary', 'Brief Summary', { rows: 6 })}
				{getSelectRow('overall_status', 'Recruitment Status', getRecruitStatusOptions())}
			</Card.Body>
		</Card>

		<Card
			ref={refs[1]}
			className="mt-4"
		>
			<Card.Header>Trial at a Glance</Card.Header>
			<Card.Body>
				{fieldHeaderRow()}
				{getSelectCreatableRow('conditions', 'Conditions', conditionOptions, true)}
				{getTextRow('textInput', 'intervention_name', 'Intervention Name')}
				{getTextRow('textInput', 'enrollment', 'Enrollment')}
				{getDatePickerRow('start_date', 'Start Date')}
				{getDatePickerRow('completion_date', 'Completion Date')}
			</Card.Body>
		</Card>

		<Card
			ref={refs[2]}
			className="mt-4"
		>
			<Card.Header>Key Requirements</Card.Header>
			<Card.Body>
				{fieldHeaderRow()}
				{getSelectRow('gender', 'Sex', getSexOptions())}
				{getSelectAge('maximum_age', 'Maximum Age')}
				{getSelectAge('minimum_age', 'Minimum Age')}
				{getToggle('accept_healthy_volunteers')}
			</Card.Body>
		</Card>

		<Card
			ref={refs[3]}
			className="mt-4"
		>
			<Card.Header>Trial Details / Participant Requirements</Card.Header>
			<Card.Body>
				{fieldHeaderRow()}
				{getSelectRow('trial_phase', 'Trial Phase', getTrialPhaseOptions())}
				{getSelectRow('trial_type', 'Trial Type', getTrialTypeOptions())}
				{getTextRow("textInput", "trial_design", "Trial Design")}
			</Card.Body>
		</Card>

		<Card className="mt-4">
			<Card.Header ref={refs[4]}>Trial Results</Card.Header>
			<Card.Body>
				{fieldHeaderRow()}
				{getDatePickerRow('results_first_posted', 'Results Posted')}
				{getFieldGroupArray(
					'trial_arms_group',
					'Trial Arms Group',
					trialArmsFields,
				)}
				{getFieldGroupArray(
					'primary_outcome_measures',
					'Primary Outcome Measures',
					outcomeMeasureFields,
				)}
				{getFieldGroupArray(
					'secondary_outcome_measures',
					'Secondary Outcome Measures',
					outcomeMeasureFields,
				)}
				{getTextRow('textArea', 'eligibility_criteria', 'Eligibility Criteria', { rows: 10 })}
			</Card.Body>
		</Card>
	</>
}

// TODO: move styles to formUtils?

const SubSectionHeader = styled.div`
  font-size: 18px;
  font-weight: bold;
  font-color: #000000;
  margin-bottom: 14px;
`

// text input, textarea

const OverrideTextFieldStyled = styled.div`
	.bx--text-input, .bx--dropdown, .bx--text-area {
		background-color: ${({ isDirty }) => isDirty && `#e6f7ff !important`};
	}
`

const OrigTextFieldStyled = styled.div`
	.bx--text-input:focus, .bx--text-input:active,
	.bx--text-area:focus, .bx--text-area:active {
			outline: none;
	}
`

// date picker field

const OverrideDatePickerStyled = styled.div`
	.bx--date-picker {
		width: 100%
	}
	.bx--date-picker-container {
		width: 100%;
	}
	.bx--date-picker.bx--date-picker--single .bx--date-picker__input {
		width: 100%;
		background-color: ${({ isDirty }) => isDirty && `#e6f7ff !important`};
	}
`

// select field

const OriginalSelectStyled = styled.div`
	width: 100%;
	border-bottom: 1px dotted rgb(141, 141, 141);
	color: ${({ isOverridden }) => isOverridden ? '#c6c6c6' : '#161616'};

	.bx--label {
		color: ${({ isOverridden }) => isOverridden ? '#c6c6c6' : '#161616'};
	}

	.orig-select-inner-box {
		align-items: center;
		display: flex;
		flex: 1 1 0%;
		padding: 2px 8px;
		min-height: 38px;
		line-height: 14px;
		user-select: all;
		flex-wrap: wrap;
	}
`

// for one item
const OrigSelectValueStyled = styled.div`
	display: flex;
`

// for multiple items
const OrigValueTagStyled = styled(OrigSelectValueStyled)`
	color: ${({ isOverridden }) => isOverridden ? '#8c8c8c' : 'rgb(51, 51, 51)'};
	background-color: ${({ isOverridden }) => isOverridden ? '#f5f5f5' : 'rgb(230, 230, 230)'};
	border-radius: 2px;
	font-size: 85%;
	margin: 2px;
	margin-right: 6px;
	padding: 3px 6px 3px 6px;
	text-overflow: ellipsis;
	white-space: nowrap;
`

// toggle field

const OverrideToggleStyled = styled.div`
	.bx--toggle__switch {
		color: ${({ isDirty }) => isDirty && '#288195'};
	}
`

const OrigToggleStyled = styled.div`
	.bx--toggle__text--off, .bx--toggle__text--on {
		color: ${({ isOverridden }) => isOverridden ? '#c6c6c6' : '#525252'};
	}
`

export default DetailCTG